module.exports = __webpack_public_path__ + "img/fatora.d8508248.png";